module.exports = __webpack_public_path__ + "img/forte-19.74be1f89.png";